import 'babel-polyfill'
import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import VueMoment from 'vue-moment'
import VueSnotify from 'vue-snotify'
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate'
import VeeValidateFr from 'vee-validate/dist/locale/fr'
import i18n from './i18n'
import NotificationServicePlugin from './plugins/notificationServicePlugin'
import JsonExcel from 'vue-json-excel'
import {INotificationService} from '@/services/NotificationService'
import '../node_modules/vue-snotify/styles/simple.css'

const frJson = require('./locales/fr.json')
// import * as frJson from './locales/fr.json'

const SnotifyOptions = {
    global: {
        maxOnScreen: 4,
        oneAtTime: false,
        pauseOnHover: true,
        timeout: 4000,
    },
    toast: {
        position: 'rightTop',
    },
}

Validator.extend('NotEduVd', {
    validate(value, args) {
        return !value.endsWith("@edu-vd.ch");
    }
})
Vue.use(VueAxios, Axios)
Vue.use(VueSnotify, SnotifyOptions)
Vue.use(VueMoment)
Vue.use(NotificationServicePlugin)

const iupErrorValidation = frJson.CUSTOM.IUP
const groupNameErrorValidation = frJson.CUSTOM.GroupName
const groupEmailErrorValidation = frJson.CUSTOM.GroupEmail
const NotEduVD = frJson.EXTRAS.MailCannotBeEduVd

const customFieldMessages = {
    custom: {
        "Courriel secondaire": {
            NotEduVd: () => NotEduVD,
        },
        IUP: {
            regex: () => iupErrorValidation,
        },
        GroupName: {
            is: () => groupNameErrorValidation,
        },
        GroupEmail: {
            is: () => groupEmailErrorValidation,
        },
    },
}

Validator.localize('fr', customFieldMessages)

Vue.use(VeeValidate, {
    locale: 'fr',
    dictionary: {
        fr: VeeValidateFr,
    },
    fieldsBagName: 'vee-fields',
})

Vue.component('downloadExcel', JsonExcel)
Vue.config.productionTip = false

// Axios settings
Axios.defaults.baseURL = process.env.VUE_APP_API
Axios.defaults.withCredentials = true
Axios.interceptors.response.use(
    (response: any) => {
        return response
    },
    (error: any) => {
        if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.code === 'token_not_valid'
        ) {
            store.dispatch('logout')
            router.push({path: '/login', query: {action: 'expired'}})
            return Promise.resolve({data: '401 - Token Expired'})
        } else {
            return Promise.reject(error)
        }
    },
)

const app = new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: (h) => h(App),
}).$mount('#app')

// @ts-ignore
if (window.Cypress) {
    // @ts-ignore
    window.app = app
}
